module.exports = __webpack_public_path__ + "button-arrow-white-prev.svg?41a74e6df9f1643785e0c4feaa7ae5a6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/button-arrow-white-prev.svg
// module id = 53
// module chunks = 0